<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Invoice</h2>
      </div>
      <div class="modal-body">
        <form #invoiceForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                  <label for="invoiceDate">Invoice Date</label>
                  <input type="date" class="form-control" name="invoiceDate" id="invoiceDate"  placeholder="Invoice Date" ngModel required>
              </div>
              <div class="form-group">
                <label for="amount">Amount</label>
                <input class="form-control" name="amount" id="amount"  placeholder="Amount" ngModel required>
            </div>
            <div class="form-group">
                <label for="notes">Notes</label>
                <textarea class="form-control" name="notes" id="notes" rows="5" placeholder="Notes" ngModel></textarea>
            </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="saveInvoice(invoiceForm.value)" [disabled]="invoiceForm.invalid">Save Invoice</button>
          <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>